<template>
  <v-dialog
      v-model="dialogVisible"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
      class="d-flex flex-column"
  >
    <v-card tile class="d-flex flex-column" style="height: 100vh;">
      <!-- Topo -->
      <div id="titulo-dialog" class="df pa-4 d-flex align-center" style="flex-shrink: 0; position: relative; z-index: 5; background: #071a2a;">
        <v-btn icon dark @click="handleFecharDialog" class="me-4">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <img :src="logo" alt="webcotacao" class="h-35px">
      </div>

      <!-- Breadcrumbs/Barra título + ações -->
      <div class="px-6 pb-4" style="flex-shrink: 0; background: white; position: relative; z-index: 3; box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);">
        <div class="d-flex align-center justify-space-between mb-3">
          <div>
            <div class="d-flex align-center">
              <v-btn icon @click="handleFecharDialog" class="mr-2">
                <v-icon color="grey darken-2">mdi-arrow-left</v-icon>
              </v-btn>
              <h2 class="font-weight-bold mr-3 text-h6">Pré-visualização carrinho {{ idCotacao ? `#${idCotacao}` : '' }}</h2>
            </div>
            <div class="mt-2">
              <v-text-field
                  v-model="searchQuery"
                  placeholder="Buscar por EAN/GTIN, SKU ou Descrição"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  clearable
                  hide-details
                  style="max-width: 500px;"
              />
            </div>
          </div>

          <div>
            <v-btn
                v-if="selected.length === 0"
                class="wc-btn-actions"
                color="error"
                text
                :disabled="produtos.length === 0"
                @click="handleClear()"
            >
              Limpar lista
            </v-btn>

            <v-btn
                v-else
                class="wc-btn-actions"
                color="error"
                text
                @click="handleExcluirSelecionados"
            >
              Excluir selecionados
            </v-btn>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="mx-2 wc-btn-actions"
                  color="primary"
                  outlined
                  @click="handlePercentTolerancia()"
                >
                  Limites de quantidade
                </v-btn>
              </template>
              <span>Defina quanto o fornecedor pode reduzir ou aumentar a quantidade que você pediu, para ajustar mínimos e fardos/caixas.</span>
            </v-tooltip>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <!-- Estado vazio com opção de reset -->
        <div v-if="produtos.length === 0 && !isLoading" class="wc-empty-state">
            <v-icon size="80" color="#c2c9d6" class="mb-4">mdi-cart-remove</v-icon>
            <h3 class="wc-empty-title">Todos os itens foram removidos</h3>
            <p class="wc-empty-subtitle">
              Você pode restaurar a lista original de produtos ou fechar para salvar as alterações.
            </p>
            <v-btn color="primary" class="mt-4 text-capitalize" @click="handleResetProdutos">
              <v-icon left>mdi-restore</v-icon>
              Restaurar Itens
            </v-btn>
        </div>

        <!-- Tabela de dados -->
        <sys-data-table
            v-else
            class="wc-table-fixed-column"
            :headers="headers"
            :items="produtosFiltrados"
            item-key="_itemId"
            v-model="selected"
            show-select
            :height="alturaTabela"
            item-height="50"
            :loading="isLoading"
        >
          <!-- headers com tooltip -->
          <template v-for="h in headers" v-slot:[`header.${h.value}.text`]="{ header }">
            <v-tooltip v-if="h.tooltip" bottom :key="h.value">
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" v-bind="attrs" class="d-flex align-center cursor-help">
                  <span v-text="header.text" />
                  <v-icon small class="ml-1" color="grey darken-1">mdi-help-circle-outline</v-icon>
                </div>
              </template>
              <span>{{ h.tooltip }}</span>
            </v-tooltip>
            <span v-else :key="h.value" v-text="header.text" />
          </template>

          <template v-slot:[`item.min_aceitavel`]="{ item }">
            <InputNumber
                v-model="item.min_aceitavel"
                center
                class="input-regular w-100 font-resp txt-table-prod"
            />
          </template>

          <template v-slot:[`item.qtd_pedida`]="{ item }">
            <InputNumber
                v-model="item.qtd_pedida"
                center
                class="input-regular w-100 font-resp txt-table-prod"
            />
          </template>

          <template v-slot:[`item.max_aceitavel`]="{ item }">
            <InputNumber
                v-model="item.max_aceitavel"
                center
                class="input-regular w-100 font-resp txt-table-prod"
            />
          </template>

          <template v-slot:[`item.qtd_pedida_na_um_master`]="{ item }">
            <InputNumber
                v-model="item.qtd_pedida_na_um_master"
                center
                class="input-regular w-100 font-resp txt-table-prod"
            />
          </template>

          <template v-slot:[`item.preco_referencia`]="{ item }">
            {{ formatBRL(item.preco_referencia) }}
          </template>

          <!-- ações -->
          <template v-slot:[`item.acoes`]="{ item }">
            <div>
              <SysTooltip top text="Remover item">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-on="on" v-bind="attrs" @click.stop="handleExcluir(item)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </SysTooltip>
            </div>
          </template>

        </sys-data-table>
      </div>

      <!-- Dialog de variação de quantidade (tolerância) -->
      <PorcentagemToleranciaDialog
        :visible="openPercentTolerancia.isOpen"
        :handleClose="() => (openPercentTolerancia.isOpen = false)"
        :isAllSelected="isAllSelected"
        :selectedCount="selected.length"
        @apply-tolerancia="loadTolerancia"
      />
    </v-card>
  </v-dialog>

</template>

<script setup>
import logo from "@/assets/logo_header.png";
import InputNumber from "@/components/webcotacao/components/InputNumber.vue";
import { defineProps } from "vue";
import SysTooltip from "@/components/utils/ui_v4/tooltips/SysTooltip.vue";
import PorcentagemToleranciaDialog from "@/components/webcotacao/components/PorcentagemToleranciaDialog.vue";
import useVisualizarProdutosCotacaoDialog from "@/components/webcotacao/composables/useVisualizarProdutosCotacaoDialog";

const props = defineProps({
  visible: { type: Boolean },
  idCotacao: { type: Number },
  handleClose: { type: Function },
});

const {
  dialogVisible,
  isLoading,
  produtos,
  selected,
  searchQuery,
  openPercentTolerancia,
  headers,
  produtosFiltrados,
  alturaTabela,
  isAllSelected,
  handleFecharDialog,
  handleExcluir,
  handleExcluirSelecionados,
  handleClear,
  formatBRL,
  handlePercentTolerancia,
  loadTolerancia,
  handleResetProdutos,
} = useVisualizarProdutosCotacaoDialog(props);
</script>

